import React from "react";

import { useSelector } from "../../utils/hooks";


export const Product = () => {
	const products = useSelector((state) => state.popup.products);

	const boughtProducts = products?.chosenProducts
		.concat(products?.mainProduct)
		.reverse();

	const chosenProduct = boughtProducts[0];

	if (!chosenProduct?.productId) {
		return null;
	}

	return (
		<section
			className="addtocart-product__container"
		>
			<div className="image-wrapper">
				<img
					data-testid="product-image"
					className="addtocart-productslist__photo"
					alt={products.mainProduct.productName}
					src={products.mainProduct.imgUrl}
					width="120"
					height="90"
					decoding="async"
				/>

				<p className="product-details">
					<a
						href={chosenProduct.url}
						target="_blank"
						data-testid="product-name"
						rel="noreferrer"
					>
						{chosenProduct.productName}
					</a>
					<span>{chosenProduct.description}</span>
				</p>
			</div>

			<p data-testid="product-price" className="product-price">
				{chosenProduct.price}
			</p>
		</section>
	);
};
